module.exports = __webpack_public_path__ + "static/media/yuan1.88f73b6f.png";